import { defineComponent, h } from 'vue'
import { validStr } from 'booksprout'

import { bsComponentProps, useBsComponent } from '../useBsComponent'
import { useVm } from '../../../composables/useVm'

/**
 * The heading block above a stepper page: a title, an optional description and an optional hint, with the
 * page's own actions slotted beside them.
 *
 * All three are rendered as HTML rather than text, because the copy carries links and emphasis.
 */
export default defineComponent({
  name: 'BsTabStepperTitle',

  props: {
    ...bsComponentProps,
    title: { type: String, default: void 0 },
    description: { type: String, default: void 0 },
    hint: { type: String, default: void 0 }
  },

  setup (props, { emit }) {
    return { ...useBsComponent({ vm: useVm(), props, emit }) }
  },

  methods: {
    // Renamed from `__renderX`: Vue does not proxy keys beginning with `_` onto the instance.
    renderTitle () {
      if (!validStr(this.title)) return void 0

      return h('h1', {
        class: 'bs-stepper-title__title',
        innerHTML: this.title
      })
    },

    renderDescription () {
      if (!validStr(this.description)) return void 0

      return h('div', {
        class: 'bs-stepper-title__description',
        innerHTML: this.description
      })
    },

    renderHint () {
      if (!validStr(this.hint)) return void 0

      return h('div', {
        class: 'bs-stepper-title__hint',
        innerHTML: this.hint
      })
    },

    renderTitleContainer () {
      return h('div', {
        class: 'bs-stepper-title__content'
      // Filtered: Vue 2 dropped an undefined child, Vue 3 renders a comment node for it.
      }, [
        this.renderTitle(),
        this.renderDescription(),
        this.renderHint()
      ].filter(child => child !== void 0))
    }
  },

  render () {
    return h('div', {
      class: 'bs-stepper-title'
    }, [
      this.renderTitleContainer(),
      h('div', {
        class: 'bs-stepper-title__actions'
      }, this.slot(this, 'default'))
    ])
  }
})
